/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { formatDateTime } from 'connex-utils-node-v4/dates';

/**
 * Shared ticket datetime formatter (StatusTimes, QR, delivery templates).
 * Space + letter TZ abbrev; no parentheses.
 *
 * @param {string} isoDateTime
 * @param {{ dateFormat?: string, use24HourTimeFormat?: boolean, timeZone?: string, mode?: 'date'|'time'|'datetime', locale?: string }} [options]
 * @returns {string}
 */
export const formatTicketDateTime = (
  isoDateTime,
  { dateFormat, use24HourTimeFormat, timeZone, mode = 'datetime', locale } = {}
) => {
  if (!isoDateTime) {
    return '';
  }

  return (
    formatDateTime(isoDateTime, {
      dateFormat,
      use24HourTimeFormat,
      timeZone,
      mode,
      locale,
    }) ?? ''
  );
};
